const KeyCodes = {
  RETURN: 13,
  ESCAPE: 27,
  UP: 38,
  DOWN: 40,
  TAB: 9
};
export default KeyCodes;